const initialState = {
  faqs: null,
}

export default initialState;
